export const SCHEMA_ORDER_BY_LOCALE: Record<string, string[]> = {
  nl: [
    "INT",
    "EU",
    "FR",
    "IT",
    "DE",
    "UK",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  be: [
    "INT",
    "EU",
    "FR",
    "IT",
    "DE",
    "UK",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  es: [
    "INT",
    "EU",
    "FR",
    "IT",
    "DE",
    "UK",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  pl: [
    "INT",
    "EU",
    "FR",
    "IT",
    "DE",
    "UK",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  it: [
    "INT",
    "IT",
    "EU",
    "FR",
    "DE",
    "UK",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  fr: [
    "INT",
    "FR",
    "EU",
    "IT",
    "DE",
    "UK",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  de: [
    "INT",
    "DE",
    "EU",
    "FR",
    "IT",
    "UK",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  uk: [
    "INT",
    "UK",
    "EU",
    "US",
    "FR",
    "IT",
    "DE",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  us: [
    "INT",
    "US",
    "EU",
    "UK",
    "FR",
    "IT",
    "DE",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
  default: [
    "INT",
    "EU",
    "UK",
    "FR",
    "IT",
    "DE",
    "US",
    "Chest",
    "Waist",
    "Cup",
    "Height",
  ],
};

const LOCALE_ALIAS: Record<string, string> = {
  "en-gb": "uk",
  "en-us": "us",
  en: "default",
  "de-at": "de",
  "nl-be": "nl",
  "fr-be": "fr",
  "es-es": "es",
  "it-it": "it",
  "pl-pl": "pl",
};

export const getSchemaOrder = (locale: string): string[] => {
  const raw = (locale || "default").toLowerCase();
  const key = LOCALE_ALIAS[raw] || raw;
  return SCHEMA_ORDER_BY_LOCALE[key] || SCHEMA_ORDER_BY_LOCALE.default;
};

export const orderSchemas = (
  groups: Record<string, unknown>,
  order: string[]
): string[] => {
  const keys = Object.keys(groups);
  const normalize = (k: string) => (k?.toLowerCase() === "other" ? "Other" : k);
  const normalizedKeys = keys.map(normalize);
  const withoutOther = normalizedKeys.filter((k) => k !== "Other");
  const primary = order.filter((k) => withoutOther.includes(k));
  const rest = withoutOther.filter((k) => !order.includes(k));
  const hasOther = normalizedKeys.includes("Other");
  return hasOther ? [...primary, ...rest, "Other"] : [...primary, ...rest];
};
